import {API} from 'shared/constants/AppEnums';

export const getListAksiPerubahan = async (query, page,ext) => {
  try {
    const response = await fetch(
      API.GET_LIST_AKSI_PERUBAHAN.replace('$query', query) +
        '&page=' +
        (page + 1) +
       ext,
      {
        method: 'GET',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );
    return response.json();
  } catch (error) {
    return error;
  }
};

export const getDetailAksiPerubahan = async (id) => {
  try {
    const response = await fetch(
      API.POST_AKSI_PERUBAHAN +id,
      {
        method: 'GET',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );
    return response.json();
  } catch (error) {
    return error;
  }
};



export const getDashboardAksiPerubahan = async (payload = undefined) => {
  try {
    const response = await fetch(
      API.POST_AKSI_PERUBAHAN+"dashboard/title/"+(payload ? `?unker=${payload.unker}&satker=${payload.satker}` :''),
      {
        method: 'GET',
        headers: {
          Authorization: sessionStorage.getItem('token'),
        },
      },
    );
    return response.json();
  } catch (error) {
    return error;
  }
};

export const postAksiPerubahan = async (payload, file) => {
  try {
    let formData = new FormData();
    formData.append('profile_nip', payload.profile_nip);
    formData.append('unker', payload.unker);
    formData.append('satker', payload.satker);
    formData.append('title_id', payload.title_id);
    formData.append('implementation', payload.implementation === null ? '' :payload.implementation);
    formData.append('file', file);
    formData.append('order', payload.order === null ? '' :payload.order );
    formData.append('note', payload.note)  === null ? '' :payload.note;
    formData.append('coach_nip', payload.coach_nip  === null ? '' :payload.coach_nip);
    formData.append('rating', payload.rating  === null ? '' :payload.rating);
    formData.append('benefit', payload.benefit  === null ? '' :payload.benefit);


    const response = await fetch(API.POST_AKSI_PERUBAHAN, {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
      body: formData,
    });
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const updateAksiPerubahan = async (id, payload, file) => {
  try {
    let formData = new FormData();
    formData.append('profile_nip', payload.profile_nip);
    formData.append('unker', payload.unker);
    formData.append('satker', payload.satker);
    formData.append('title_id', payload.title_id);
    formData.append('implementation', payload.implementation === null ? '' :payload.implementation);
    formData.append('order', payload.order === null ? '' :payload.order );
    formData.append('note', payload.note === null ? '' :payload.note);
    formData.append('coach_nip', payload.coach_nip  === null ? '' :payload.coach_nip);
    formData.append('rating', payload.rating  === null ? '' :payload.rating);
    formData.append('benefit', payload.benefit  === null ? '' :payload.benefit);


    if(file.file !== '')
    formData.append('file', file);
    const response = await fetch(API.POST_AKSI_PERUBAHAN + id, {
      method: 'PUT',
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
      body: formData,
    });
    return response.json();
  } catch (error) {
    throw error;
  }
};



export const postJenisKategori = async (body) => {
  try {
    const response = await fetch(API.POST_AKSI_PERUBAHAN + "title/", {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'      },
      body:JSON.stringify(body)
    });
    const data = await response.json()
    return data;
  } catch (error) {
    throw error;
  }
};

export const detailAksiPerubahan = async (id) => {
  try {
    const response = await fetch(API.POST_AKSI_PERUBAHAN + id, {
      method: 'GET',
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });
    return response.json();
  } catch (error) {
    return error;
  }
};

export const deleteAksiPerubahan = async (id) => {
  try {
    const response = await fetch(API.POST_AKSI_PERUBAHAN, {
      method: 'DELETE',
      headers: {
        Authorization: sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ids: [id]}),
    });
    return response.json();
  } catch (error) {
    return error;
  }
};

export const importAksiPerubahan = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await fetch(API.POST_AKSI_PERUBAHAN + 'import/', {
      method: 'POST',
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
      body: formData,
    });
    return response.json();
  } catch (error) {
    return error;
  }
};
